import { Injectable } from '@angular/core';
import {
  Cart,
  ORDER_ENTRY_PROMOTIONS_NORMALIZER,
  OrderEntry,
} from '@spartacus/cart/base/root';
import {
  Converter,
  ConverterService,
} from '@spartacus/core';
import { EntryGroup } from 'src/app/generac/models/cart.model';

@Injectable({providedIn: 'root'})
export class GenOccCartNormalizer implements Converter<Cart, Cart> {
  constructor(private converter: ConverterService) {
  }

  convert(source: Cart, target?: Cart): Cart {
    if (target === undefined) {
      target = {...(source as any)} as Cart;
    }

    this.removeDuplicatePromotions(source, target);
    const promosIds: number[][] = target?.appliedProductPromotions?.map(promo => promo.consumedEntries.map(consumedEntry => consumedEntry.orderEntryNumber));

    if (source?.entries) {
      target.entries = source.entries.map((entry: OrderEntry) => this.convertCartEntry(entry, target, promosIds));
    }

    if (source?.entryGroups) {
      target.entryGroups = source.entryGroups.map((entryGroup: EntryGroup) => {
        let entryGroupEntries: OrderEntry[] = [];

        if (entryGroup.type === 'CONFIGURABLEBUNDLE') {
          entryGroupEntries = entryGroup.entryGroups[0].entries.map((entry) =>
            this.convertCartEntry(entry, target, promosIds));

          return {
            ...entryGroup,
            entryGroups: [{
              ...entryGroup.entryGroups[0],
              entries: entryGroupEntries
            }]
          } as EntryGroup;
        } else {
          entryGroupEntries = entryGroup.entries.map((entry: OrderEntry, index)=>
            this.convertCartEntry(entry, target, promosIds));
          return {
            ...entryGroup,
            entries: entryGroupEntries
          } as EntryGroup;
        }
      })
    }

    if (source?.shippingGroups) {
      target.shippingGroups = source?.shippingGroups.flatMap((sg) => {
        return {
          ...sg,
          manufactureGroups: sg.manufactureGroups?.flatMap((mg) => {
            return {
              ...mg,
              entryGroups: mg.entryGroups.flatMap((eg) => {
                return {
                  ...eg,
                  entries: eg.entries.map(e => this.convertCartEntry(e, target, promosIds))
                }
              })
            }
          })
        }
      })
    }
    return target;
  }

  /**
   * Remove all duplicate promotions
   */
  private removeDuplicatePromotions(source: any, target: Cart): void {
    if (source && source.potentialOrderPromotions) {
      target.potentialOrderPromotions = this.removeDuplicateItems(
        source.potentialOrderPromotions
      );
    }

    if (source && source.potentialProductPromotions) {
      target.potentialProductPromotions = this.removeDuplicateItems(
        source.potentialProductPromotions
      );
    }

    if (source && source.appliedOrderPromotions) {
      target.appliedOrderPromotions = this.removeDuplicateItems(
        source.appliedOrderPromotions
      );
    }

    if (source && source.appliedProductPromotions) {
      target.appliedProductPromotions = this.removeDuplicateItems(
        source.appliedProductPromotions
      );
    }
  }

  private convertCartEntry(entry: OrderEntry, target: Cart, promosIds: number[][]): OrderEntry {
    return {
      ...entry,
      promotions: this.converter.convert(
        {item: entry, promotions: this.getActualPromos(promosIds, entry, target)},
        ORDER_ENTRY_PROMOTIONS_NORMALIZER
      )
    }
  }

  private removeDuplicateItems(itemList: any[]): any[] {
    return itemList.filter((p, i, a) => {
      const b = a.map((el) => JSON.stringify(el));
      return i === b.indexOf(JSON.stringify(p));
    });
  }

  private getActualPromos(promosIds: number[][], entry: OrderEntry, target: Cart) {
    const actualPromotionsIndexes = promosIds?.map((promoIds) =>
      promoIds.some(promoId => promoId === entry.entryNumber)
    );
    return target?.appliedProductPromotions?.filter((_, index) => actualPromotionsIndexes[index]);
  }
}
